export default __webpack_public_path__ + "static/media/superboost-gray.6ccd9a2d.svg";